export const states = [
  "Abia",
  "FCT",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];

export const institutions = [
  {
    state: "Abia",
    schools: [
      " College of Nursing Sciences, Midwifery Programme, Amachara, Abia State",
      "Archbishop Charles Heerey College of Nursing Sciences, Midwifery Programme, Aba, Abia State",
      "Archbishop Charles Heerey College of Nursing Sciences, Nursing Programme, Aba, Abia State",
      "College of Nursing Sciences, ABSUTH,Midwifery Programme Aba, Abia State",
      "College of Nursing Sciences, Mental Health/Psychiatric Nursing Programme, Aba, Abia State",
      "College of Nursing Sciences, Midwifery Programme, Abiriba, Abia State",
      "College of Nursing Sciences, Midwifery Programme, ABSUTH, Aba, Abia State",
      "College of Nursing Sciences, Midwifery Programme, Obahia-Ndoki, Abia State",
      "College of Nursing Sciences, Midwifery Programme, Umuahia, Abia State",
      "College of Nursing Sciences, Nursing Programme, ABSUTH, Aba, Abia State",
      "College of Nursing Sciences, Nursing Programme, Amachara, Abia State",
      "College of Nursing Sciences, Nursing Programme, Obahia-Ndoki, Abia State",
      "College of Nursing Sciences, Nursing Programme, Umuahia, Abia State",
      "Department of Nursing Sciences, Abia State University, Uturu, Abia State",
      "Department of Nursing Sciences, Clifford University, Owerrinta, Ihie Campus, Abia State",
      "Department of Nursing Sciences, Gregory University, Uturu, Abia State",
      "Department of Nursing Sciences, Rhema University, Aba, Abia State",
      "St. Anthony's College of Nursing Sciences, Nursing Programme, Aba, Abia State",
    ],
  },
  {
    state: "FCT",
    schools: [
      "College of Nursing Sciences, Midwifery Programme, Gwagwalada, Abuja FCT",
      "College of Nursing Sciences, Midwifery Programme, Jahi, Abuja FCT",
      "Horizon College of Nursing Sciences, Midwifery Programme, Anagada, Abuja FCT",
      "College of Nursing Sciences, Critical Care Nursing Programme, UATH, Gwagwalada, Abuja",
      "College of Nursing Sciences, Nephrology Nursing Programme, National Hospital, Abuja FCT",
      "College of Nursing Sciences, Nursing Programme, Gwagwalada, Abuja FCT",
      "College of Nursing Sciences, Nursing Programme, Jahi, Abuja FCT",
      "College of Nursing Sciences, Oncology Nursing Programme, National Hospital, Abuja FCT",
      "Department of Nursing Sciences, Veritas University, Bwari, Abuja",
      "Horizon College of Nursing Sciences, Nursing Programme, Anagada, Abuja FCT",
      "National Open University of Nigeria, Abuja",
      "Unity College of Nursing Sciences, Midwifery Programme, Bwari, Abuja FCT",
      "Unity College of Nursing Sciences, Nursing Programme, Bwari, Abuja FCT",
      "Yagongwo College of Nursing Sciences, Midwifery Programme, Kuje, Abuja FCT",
      "Yagongwo College of Nursing Sciences, Nursing Programme, Kuje, Abuja FCT",
    ],
  },
  {
    state: "Adamawa",
    schools: [
      "College of Nursing Sciences, Accident and Emergency Nursing Programme, MAUTH, Yola, Adamawa State",
      "College of Nursing Sciences, Community Midwifery Programme, Yola, Adamawa State",
      "College of Nursing Sciences, Community Nursing Programme, Yola, Adamawa State",
      "College of Nursing Sciences, Midwifery Programme, MAUTH, Yola, Adamawa State",
      "College of Nursing Sciences, Midwifery Programme, Yola, Adamawa State",
      "College of Nursing Sciences, Neonatal Nursing Programme, MAUTH, Yola, Adamawa State",
      "College of Nursing Sciences, Nursing Programme, MAUTH, Yola, Adamawa State",
      "College of Nursing Sciences, Nursing Programme, Yola, Adamawa State",
      "College of Nursing Sciences, Peadiatrics Programme, MAUTH, Yola, Adamawa State",
      "College of Nursing Sciences, Perioperative Nursing Programme, MAUTH, Yola, Adamawa State",
      "Department of Nursing Sciences, American University of Nigeria, Yola, Adamawa State",
      "School of Community Midwifery, Yola, Adamawa State",
      "School of Post Basic Accident and Emergency Nursing, MAUTH, Yola, Adamawa State",
    ],
  },
  {
    state: "Akwa Ibom",
    schools: [
      "College of Nursing Sciences, Mental Health/ Psychiatric Nursing Programme, Eket, Akwa Ibom State",
      "College of Nursing Sciences, Midwifery Programme, Anua-Uyo, Akwa Ibom State",
      "College of Nursing Sciences, Midwifery Programme, Iquita-Oron, Akwa Ibom State",
      "College of Nursing Sciences, Midwifery Programme, Ituk-Mbang, Akwa Ibom State",
      "College of Nursing Sciences, Midwifery Programme, Qua Iboe Church Hospital, Etinan, Akwa Ibom State",
      "College of Nursing Sciences, Midwifery Programme, Urua-Akpan, Akwa Ibom State",
      "College of Nursing Sciences, Nursing Programme, Anua-Uyo, Akwa Ibom State",
      "College of Nursing Sciences, Nursing Programme, Eket, Akwa Ibom State",
      "College of Nursing Sciences, Nursing Programme, Ikot-Ekpene, Akwa Ibom State",
      "College of Nursing Sciences, Nursing Programme, Ituk-Mbang, Akwa Ibom State",
      "Department of Nursing Sciences, University of Uyo, Uyo, Akwa Ibom State",
    ],
  },
  {
    state: "Anambra",
    schools: [
      " Department of Nursing Sciences, Tansian University, Umunya, Anambra State                      ",
      "Apex College of Nursing Sciences, Nursing Programme, Igbo-Ukwu, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, Adazi-Nnukwu, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, Alor, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, Amichi, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, Ihiala, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, Iyi-Enu, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, NAUTH, Nnewi, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, Nkpor, Anambra State",
      "College of Nursing Sciences, Midwifery Programme, Waterside, Onitsha, Anambra State",
      "College of Nursing Sciences, Nursing Programme, Adazi-Nnukwu, Anambra State",
      "College of Nursing Sciences, Nursing Programme, Alor, Anambra State",
      "College of Nursing Sciences, Nursing Programme, Amichi, Anambra State",
      "College of Nursing Sciences, Nursing Programme, Ihiala, Anambra State",
      "College of Nursing Sciences, Nursing Programme, Iyi-Enu, Anambra State",
      "College of Nursing Sciences, Nursing Programme, NAUTH ,Nnewi,  Anambra State",
      "College of Nursing Sciences, Nursing Programme, NAUTH, Nnewi, Anambra State",
      "College of Nursing Sciences, Nursing Programme, Nkpor, Anambra State",
      "Department of Nursing Sciences, Nnamdi Azikwe University, Nnewi, Anambra State",
      "Department of Nursing Sciences, Tansian University, Umunya, Anambra State",
      "Millennium College of Nursing Sciences, Nursing Programme, Awka, Anambra State",
      "St Charles Boromeo College of Nursing Sciences, Nursing Programme, Onitsha, Anambra State",
    ],
  },
  {
    state: "Bauchi",
    schools: [
      "Adamu Adamu College of Nursing Sciences, Midwifery Programme, FMC, Azare, Bauchi State",
      "Adamu Adamu College of Nursing Sciences, Nursing Programme, FMC, Azare, Bauchi State",
      "Aliko Dangote College of Nursing Sciences, Community Midwifery Programme, Bauchi, Bauchi State",
      "Aliko Dangote College of Nursing Sciences, Midwifery Programme, Bauchi, Bauchi State",
      "Aliko Dangote College of Nursing Sciences, Nursing Programme, Bauchi, Bauchi State",
      "College of Nursing Sciences, Community Nursing Programme, Bauchi, Bauchi State",
      "College of Nursing Sciences, Midwifery Programme, ATBUTH, Bauchi, Bauchi State",
      "College of Nursing Sciences, Nursing Programme, ATBUTH, Bauchi, Bauchi State",
      "College of Nursing Sciences, Perioperative Nursing Programme, ATBUTH, Bauchi, Bauchi State",
    ],
  },
  {
    state: "Bayelsa",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Tombia, Bayelsa State",
      "College of Nursing Sciences, Community Nursing Programme, Tombia, Bayelsa State",
      "College of Nursing Sciences, Midwifery Programme, Tombia, Bayelsa State",
      "College of Nursing Sciences, Nursing Programme, Tombia, Bayelsa State",
      "Faculty of Nursing Science, NDU, Wilberforce Island, Bayelsa State",
      "Faculty of Nursing Sciences, Niger Delta University, Amassoma, Bayelsa State",
    ],
  },
  {
    state: "Benue",
    schools: [
      "College of Nursing Sciences, Midwifery Programme, Makurdi, Benue State",
      "College of Nursing Sciences, Nephrology Nursing Programme, Benue State University Teaching Hospital Campus, Makurdi, Benue State",
      "College of Nursing Sciences, Nursing Programme, Makurdi, Benue State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme, Benue State University Teaching Hospital Campus, Makurdi, Benue State",
      "Department of Nursing Sciences, Benue State University, Makurdi, Benue State",
      "Makurdi College of Nursing Sciences, Nursing Programme, Makurdi, Benue State",
      "NKST College of Nursing Sciences, Community Midwifery Programme, Mkar, Benue State",
      "NKST College of Nursing Sciences, Community Nursing Programme, Mkar, Benue State",
      "NKST College of Nursing Sciences, Midwifery Programme, Mkar, Benue State",
      "NKST College of Nursing Sciences, Nursing Programme, Mkar, Benue State",
    ],
  },
  {
    state: "Borno",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Maiduguri, Borno State",
      "College of Nursing Sciences, Community Nursing Programme, Maiduguri, Borno State",
      "College of Nursing Sciences, Critical Care Nursing Programme, UMTH, Maiduguri, Borno State",
      "College of Nursing Sciences, Mental Health/Psychiatric Nursing Programme, Federal Neuropsychiatric Hospital, Maiduguri, Borno State",
      "College of Nursing Sciences, Midwifery Programme, Maiduguri, Borno State",
      "College of Nursing Sciences, Nursing Programme, Maiduguri, Borno State",
      "College of Nursing Sciences, Nursing Programme, UMTH, Maiduguri, Borno State",
      "College of Nursing Sciences, Perioperative Nursing Programme, UMTH, Maiduguri, Borno State",
      "Department of Nursing Sciences, University of Maiduguri, Maiduguri, Borno State",
      "Mustapha Umar Mustapha College of Nursing Sciences, Midwifery Programme, Biu, Borno State",
      "Mustapha Umar Mustapha College of Nursing Sciences, Nursing Programme, Biu, Borno State",
      "Zenith College of Nursing Sciences, Midwifery Programme, Maiduguri, Borno State",
      "Zenith College of Nursing Sciences, Nursing Programme, Maiduguri, Borno State",
    ],
  },
  {
    state: "Cross River",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Obudu, Cross River State",
      "College of Nursing Sciences, Community Midwifery Programme, Ogoja, Cross River State",
      "College of Nursing Sciences, Community Nursing Programme, Itigidi, Cross River State",
      "College of Nursing Sciences, Community Nursing Programme, Ogoja, Cross River State",
      "College of Nursing Sciences, Mental Health/ Psychiatric Nursing Programme, Federal Neuropsychiatric Hospital, Calabar, Cross River State",
      "College of Nursing Sciences, Midwifery Programme, Calabar, Cross River State",
      "College of Nursing Sciences, Midwifery Programme, Itigidi, Cross River State",
      "College of Nursing Sciences, Midwifery Programme, Obudu, Cross River State",
      "College of Nursing Sciences, Midwifery Programme, Ogoja, Cross River State",
      "College of Nursing Sciences, Nursing Programme, Calabar, Cross River State",
      "College of Nursing Sciences, Nursing Programme, Itigidi, Cross River State",
      "College of Nursing Sciences, Nursing Programme, Obudu, Cross River State",
      "College of Nursing Sciences, Nursing Programme, Ogoja, Cross River State",
      "College of Nursing Sciences, Nursing Programme, UCTH, Calabar, Cross River State",
      "Department of Nursing Sciences, University of Calabar, Calabar, Cross River State",
      "School of Nursing, UCTH, Calabar, Cross River State",
      "Department of Nursing Science, Havilla University, Nde-Ikom Cross Rivers State",
      "Department of Nursing Science, Havilla University, Nde-Ikom, Cross Rivers State",
      "Department of Nursing Sciences, Arthur Jarvis University, Akwa Ikot Efanga, Cross Rivers State",
    ],
  },
  {
    state: "Delta",
    schools: [
      "Anchor College of Nursing Sciences, Midwifery Programme, Asaba, Delta State",
      "Anchor College of Nursing Sciences, Nursing Programme, Asaba, Delta State",
      "College of Nursing Sciences, Community Midwifery Programme, Asaba, Delta State",
      "College of Nursing Sciences, Community Midwifery Programme, Sapele, Delta State",
      "College of Nursing Sciences, Community Nursing Programme, Agbor, Delta State",
      "College of Nursing Sciences, Community Nursing Programme, Eku, Delta State",
      "College of Nursing Sciences, Community Nursing Programme, Warri, Delta State",
      "College of Nursing Sciences, Midwifery Programme, Asaba, Delta State",
      "College of Nursing Sciences, Midwifery Programme, Sapele, Delta State",
      "College of Nursing Sciences, Neonatal Nursing Programme, Federal Medical Centre, Asaba, Delta State",
      "College of Nursing Sciences, Nursing Programme, Agbor, Delta State",
      "College of Nursing Sciences, Nursing Programme, Eku, Delta State",
      "College of Nursing Sciences, Nursing Programme, Federal Medical Centre, Asaba, Delta State",
      "College of Nursing Sciences, Nursing Programme, Warri, Delta State",
      "Department of Nursing Science, Edwin Clark University, Kiagbodo, Delta State",
      "Department of Nursing Science, Novena University, Ogume, Delta State",
      "Department of Nursing Sciences, Delta State University, Abraka, Delta State",
      "Mary Martha College of Nursing Science, School of Midwifery, Oleh, Delta State",
      "Mary Martha College of Nursing Sciences, Midwifery Programme, Oleh, Delta State",
      "Mary Martha College of Nursing Sciences, Nursing Programme, Oleh, Delta State",
      "Soarstar College of Nursing Sciences, Nursing Programme, Abah-Unor, Delta State",
    ],
  },
  {
    state: "Ebonyi",
    schools: [
      "Blessed Martins College of Nursing Sciences, Midwifery Programme, Ikwo, Ebonyi State",
      "Blessed Martins College of Nursing Sciences, Nursing Programme, Ikwo, Ebonyi State",
      "College of Nursing Sciences, Accident and Emergency Nursing Programme, AEFUTH, Abakaliki, Ebonyi State",
      "College of Nursing Sciences, Critical Care Nursing Programme, AEFUTH, Abakaliki, Ebonyi State",
      "College of Nursing Sciences, Midwifery Programme, AEFUTH, Abakaliki, Ebonyi State",
      "College of Nursing Sciences, Midwifery Programme, Uburu, Ebonyi State",
      "College of Nursing Sciences, Nephrology Nursing Programme, AEFUTH, Abakaliki, Ebonyi State",
      "College of Nursing Sciences, Nursing Programme, AEFUTH, Abakaliki, Ebonyi State",
      "College of Nursing Sciences, Nursing Programme, Uburu, Ebonyi State",
      "College of Nursing Sciences, Oncology Nursing Programme, National Obstetric Fistula Centre, Abakaliki, Ebonyi State",
      "Department of Nursing Sciences, Ebonyi State University, Abakaliki, Ebonyi State",
      "Department of Nursing Sciences, Evangel University, Akaeze, Ebonyi State",
      "Eastern Oak College of Nursing Sciences, Midwifery Programme, Ikwo, Ebonyi State",
      "Eastern Oak College of Nursing Sciences, Nursing Programme, Ikwo, Ebonyi State",
      "Mater Misericordiae College of Nursing Sciences, Midwifery Programme, Afikpo, Ebonyi State",
      "Mater Misericordiae College of Nursing Sciences, Nursing Programme, Afikpo, Ebonyi State",
      "Royal College of Nursing Sciences, Midwifery Programme, Ezzangbo, Ebonyi State",
      "Royal College of Nursing Sciences, Nursing Programme, Ezzangbo, Ebonyi State",
    ],
  },
  {
    state: "Edo",
    schools: [
      "College of Nursing Sciences, Accident & Emergency Nursing Programme, University of Benin Teaching Hospital, Benin-City, Edo State",
      "College of Nursing Sciences, Gerontology Nursing Programme, UBTH, Benin-City, Edo State",
      "College of Nursing Sciences, Mental Health/ Psychiatric Nursing Programme, Uselu, Benin-City, Edo State",
      "College of Nursing Sciences, Midwifery Programme, Benin-City, Edo State",
      "College of Nursing Sciences, Midwifery Programme, University of Benin Teaching Hospital, Benin-City, Edo State",
      "College of Nursing Sciences, Midwifery Programme, Zuma Memorial Hospital, Irrua, Edo State",
      "College of Nursing Sciences, Nursing Programme, Benin-City, Edo State",
      "College of Nursing Sciences, Nursing Programme, IUTH, Okada, Edo State",
      "College of Nursing Sciences, Nursing Programme, University of Benin Teaching Hospital, Benin-City, Edo State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme, University of Benin Teaching Hospital, Benin-City, Edo State",
      "College of Nursing Sciences, Paediatric Nursing Programme, Irrua Specialist Teaching Hospital  (ISTH), Irrua, Edo State",
      "College of Nursing Sciences, Paediatric Nursing Programme, University of Benin Teaching Hospital, Benin-City, Edo State",
      "College of Nursing Sciences, Perioperative Nursing Programme,  Irrua Specialist Teaching Hospital  (ISTH), Irrua, Edo State",
      "College of Nursing Sciences, Perioperative Nursing Programme, University of Benin Teaching Hospital, Benin-City, Edo State",
      "Department of Nursing Sciences, Ambrose Alli University, Ekpoma, Edo State",
      "Department of Nursing Sciences, Edo State University (ESU),Iyamho, Edo state",
      "Department of Nursing Sciences, Edo University Uzairue, Edo State",
      "Department of Nursing Sciences, University of Benin, Benin-City, Edo State",
      "Dept of Nursing Science, Edo State University (ESU),Iyamho, Edo state",
      "Faculty of Nursing Sciences, Igbinedion University, Okada, Edo State",
      "Faculty of Nursing Sciences, Well Spring University, Benin- City, Edo State",
      "Faculty of Nursing, Benson Idahosa University, Benin City, Edo State",
      "Sancta Maria Catholic College of Nursing Sciences, Midwifery Programme, Uzairue, Edo State",
      "Sancta Maria Catholic College of Nursing Sciences, Nursing Programme, Uzairue, Edo State",
      "School of  Midwifery, UBTH, Benin-City, Edo State",
      "St. Camillus College of Nursing Sciences, Midwifery Programme, Uromi, Edo State",
      "St. Camillus College of Nursing Sciences, Nursing Programme, Uromi, Edo State",
      "St. Philomena College of Nursing Sciences, Midwifery Programme, Benin-City, Edo State",
    ],
  },
  {
    state: "Ekiti",
    schools: [
      "College of Nursing Sciecnes, Public Health Nursing Programme, EKSUTH, Ado Ekiti, Ekiti State",
      "College of Nursing Sciences, Community Midwifery Programme, EKSUTH, Ado-Ekiti, Ekiti State",
      "College of Nursing Sciences, Community Nursing Programme, EKSUTH, Ado-Ekiti, Ekiti State",
      "College of Nursing Sciences, Midwifery Programme, EKSUTH, Ado-Ekiti, Ekiti State",
      "College of Nursing Sciences, Nursing Programme, EKSUTH, Ado-Ekiti, Ekiti State",
      "College of Nursing Sciences,Nursing Programme, FTH, Ido-Ekiti, Ekiti State",
      "Department of Nursing Science, ABUAD, Ado-Ekiti, Ekiti State",
      "Department of Nursing Sciences, Ekiti State University, Ado-Ekiti, Ekiti State",
      "Department of Nursing Sciences, Venite University, Iloro -Ekiti,",
      "Department of Nursing, Federal University Oye Ekiti, Ekiti State",
      "Faculty of Nursing Sciences, Afe Babalola University, Ado-Ekiti, Ekiti State",
      "School of Community Midwifery, EKSUTH, Ado Ekiti, Ekiti State",
    ],
  },
  {
    state: "Enugu",
    schools: [
      "Bishop Shanahan College of Nursing Sciences, Midwifery Programme, Nsukka, Enugu State",
      "Bishop Shanahan College of Nursing Sciences, Nursing Programme, Nsukka, Enugu State",
      "Central Washington College of Nursing Sciences, Midwifery Programme, Enugu, Enugu State",
      "Central Washington College of Nursing Sciences, Nursing Programme, Enugu, Enugu State",
      "College of Nursing Sciences, Anaesthetic Nursing Programme, UNTH, Enugu, Enugu State.",
      "College of Nursing Sciences, Burns & Plastic Nursing Programme, National Orthopeadic Hospital, Enugu, Enugu State",
      "College of Nursing Sciences, Cardiothoracic Nursing Programme, UNTH, Enugu, Enugu State",
      "College of Nursing Sciences, Mental Health/ Psychiatric Nursing Programme, Federal Neuropsychiatric Hospital, Enugu, Enugu State",
      "College of Nursing Sciences, Midwifery Programme, Awgu, Enugu State.",
      "College of Nursing Sciences, Midwifery Programme, ESUTH, Parklane, Enugu State",
      "College of Nursing Sciences, Midwifery Programme, National Orthopedic Hospital, Enugu, Enugu State",
      "College of Nursing Sciences, Midwifery Programme, UNTH, Enugu, Enugu State",
      "College of Nursing Sciences, Nursing Programme, Agwu, Enugu State",
      "College of Nursing Sciences, Nursing Programme, ESUTTH Parklane, Enugu, Enugu State",
      "College of Nursing Sciences, Nursing Programme, National Orthopedic Hospital, Enugu, Enugu State",
      "College of Nursing Sciences, Nursing Programme, UNTH, Enugu, Enugu State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme, UNTH, Enugu, Enugu State",
      "College of Nursing Sciences, Orthopaedic Nursing Programme, National Orthopeadic Hospital, Enugu, Enugu State",
      "College of Nursing Sciences, Perioperative Nursing Programme, UNTH, Enugu, Enugu State",
      "Department of Nursing Sciences, Enugu State University of Science and Technology, Enugu, Enugu State",
      "Department of Nursing Sciences, University of Nigeria, Enugu Campus, Enugu State",
      "Federal College of Dental Technology and Therapy, Oral-Dental Nursing Programme, Enugu, Enugu State",
      "School of Midwifery, Joint Hospital, Agwu, Enugu State",
    ],
  },
  {
    state: "Gombe",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Gombe, Gombe State",
      "College of Nursing Sciences, Community Nursing, Gombe, Gombe State",
      "College of Nursing Sciences, Critical Care Nursing Programme, Federal Teaching Hospital, Gombe, Gombe State",
      "College of Nursing Sciences, Midwifery Programme, Gombe, Gombe State",
      "College of Nursing Sciences, Nursing Programme, Federal Teaching Hospital, Gombe, Gombe State",
      "College of Nursing Sciences, Nursing Programme, Gombe, Gombe State",
      "College of Nursing Sciences, Public Health Nursing Programme, Gombe, Gombe State",
      "College of Nursing Sciences,Midwifery Programme, Federal Teaching Hospital, Gombe, Gombe State",
      "College of Nursing Sciences,Perioperative Nursing Programme, Federal Teaching Hospital, Gombe, Gombe State",
      "Jewel College of Nursing Sciences, Midwifery Programme, Gombe, Gombe State",
      "Jewel College of Nursing Sciences, Nursing Programme, Gombe, Gombe State",
      "Jibwis College of Arabic & Islamic Studies, Gombe, Gombe State",
      "The Evangelical Theological Seminary, Kaltungo, Gombe State",
    ],
  },
  {
    state: "Imo",
    schools: [
      "College of Nursing Sciences, Midwifery Programme, Aboh-Mbaise, Imo State",
      "College of Nursing Sciences, Midwifery Programme, Awo-Omamma, Imo State",
      "College of Nursing Sciences, Midwifery Programme, Mbano, Imo State",
      "College of Nursing Sciences, Midwifery Programme, Umulogho-Obowo, Imo State",
      "College of Nursing Sciences, Nursing Programme, Mbano, Imo State",
      "College of Nursing Sciences, Nursing Programme, Orlu, Imo State",
      "College of Nursing Sciences, Midwifery Programme, Orlu, Imo State",
      "College of Nursing Sciences, Nursing Programme, Owerri, Imo State",
      "College of Nursing Sciences, Nursing Programme, Umulogho-Obowo, Imo State",
      "College of Nursing Sciences, School of Public Health Nursing, Orlu, Imo State",
      "Department of Nursing Sciences, Imo State University, Orlu, Imo State",
      "Ezeala College of Nursing Sciences, Accident and Emergency Nursing Programme, Okwudor, Imo State",
      "Ezeala College of Nursing Sciences, Nursing Programme, Okwudor, Imo State",
      "Holy Rosary College of Nursing Sciences, Midwifery Programme, Emekuku, Imo State",
      "Holy Rosary College of Nursing Sciences, Nursing Programme, Emekuku, Imo State",
      "International Christian College of Nursing Sciences, Midwifery Programme, Owerri, Imo State",
      "International Christian College of Nursing Sciences, Nursing Programme, Owerri, Imo State",
      "Merit College of Nursing Sciences, Midwifery Programme, Orlu, Imo State",
      "Merit College of Nursing Sciences, Nursing Programme, Orlu, Imo State",
      "Princess College of Nursing Sciences, Midwifery Programme, Mgbirichi, Imo State",
      "Princess College of Nursing Sciences, Nursing Programme, Mgbirichi, Imo State",
      "St. Joseph College of Nursing Sciences, Nursing Programme, Mbaise, Imo State",
      "St. Mary College of Nursing Sciences, Midwifery Programme, Amaigbo, Imo State",
      "St. Mary College of Nursing Sciences, Nursing Programme, Amaigbo, Imo State",
    ],
  },
  {
    state: "Jigawa",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Kudu, Jigawa State",
      "College of Nursing Sciences, Community Nursing Programme, Hadejia, Jigawa State",
      "College of Nursing Sciences, Community Nursing Programme, Kudu, Jigawa State",
      "College of Nursing Sciences, Midwifery Programme, Babura, Jigawa State",
      "College of Nursing Sciences, Midwifery Programme, Birnin Kudu, Jigawa State",
      "College of Nursing Sciences, Nursing Programme, Babura, Jigawa State",
      "College of Nursing Sciences, Nursing Programme, Birnin Kudu, Jigawa State",
      "College of Nursing Sciences, Nursing Programme, Hadejia, Jigawa State",
      "Iqra College of Nursing Science, Midwifery Programme, Duste, Jigawa State",
      "Iqra College of Nursing Science, Nursing Programme, Duste, Jigawa State",
      "Kazaure College of Nursing Sciences, Midwifery Programme, Kazaure, Jigawa State",
      "Kazaure College of Nursing Sciences, Nursing Programme, Kazaure, Jigawa State",
    ],
  },
  {
    state: "Kaduna",
    schools: [
      "College of Nursing Sciences, Anaesthetic Nursing Programme, ABUTH, Zaria, Kaduna State",
      "College of Nursing Sciences, Community Midwifery Programme, Kafanchan, Kaduna State",
      "College of Nursing Sciences, Community Midwifery Programme, Tudun Wada, Kaduna State",
      "College of Nursing Sciences, Community Nursing Programme, Kafanchan, Kaduna State",
      "College of Nursing Sciences, Community Nursing Programme, Pambeguwa, Kaduna State",
      "College of Nursing Sciences, Community Nursing Programme, Tudun Wada, Kaduna State",
      "College of Nursing Sciences, Mental Health/ Psychiatric Nursing Programme, Federal Neuropsychiatric Hospital, Barnawa, Kaduna State",
      "College of Nursing Sciences, Midwifery Programme, ABUTH, Zaria, Kaduna State",
      "College of Nursing Sciences, Midwifery Programme, Kafanchan, Kaduna State",
      "College of Nursing Sciences, Midwifery Programme, Tudun Wada, Kaduna State",
      "College of Nursing Sciences, Nursing Programme, ABUTH, Zaria, Kaduna State",
      "College of Nursing Sciences, Nursing Programme, Kafanchan, Kaduna State",
      "College of Nursing Sciences, Nursing Programme, Pambeguwa, Kaduna State",
      "College of Nursing Sciences, Nursing Programme, Tudun Wada, Kaduna State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme, ABUTH, Zaria, Kaduna State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme, National Eye Centre, Kaduna, Kaduna State",
      "College of Nursing Sciences, Otorhinolaryngology Nursing Programme, National Ear Care Centre, Kaduna, Kaduna State",
      "College of Nursing Sciences, Paediatric Nursing Programme, ABUTH, Zaria, Kaduna State",
      "College of Nursing Sciences, Perioperative Nursing Programme, ABUTH, Zaria, Kaduna State",
      "Department of Nursing Sciences, Ahmadu Bello University, Zaria, Kaduna State",
      "Department of Nursing Sciences, Greenfield University, Kaduna, Kaduna State",
      "Kaduna State College of Nursing and Midwifery, School of Community Nursing, Kafanchan, Kaduna State",
      "Muh'd IBN El-Barau College of Nursing Sciences, Midwifery Programme, Zaria. Kaduna State",
      "Muh'd IBN El-Barau College of Nursing Sciences, Nursing Programme, Zaria. Kaduna State",
      "Nigerian Airforce College of Nursing Sciences, Nursing Programme,Kaduna, Kaduna State",
      "Nigerian Airforce College of Nursing, NAFCON, Kaduna, Kaduna State.",
      "School of Community Midwifery, Tundun Wada, Kaduna State",
      "School of Post Basic Perioperative Nursing, ABUTH, Zaria, Kaduna State",
      "St Gerard College of Nursing Sciences, Midwifery Programme, Kakuri, Kaduna State",
      "St Gerard College of Nursing Sciences, Nursing Programme, Kakuri, Kaduna State",
      "St Louis College of Nursing Sciences, Midwifery Programme, Zonkwa, Kaduna State",
      "St Luke College of Nursing Sciences, Midwifery Programme, Wusasa, Kaduna State",
      "St Luke College of Nursing Sciences, Nursing Programme, Wusasa, Kaduna State",
    ],
  },
  {
    state: "Kano",
    schools: [
      "Aminu Dabo College of Nursing Sciences, Midwifery Programme, Kano, Kano State",
      "Aminu Dabo College of Nursing Sciences, Nursing Programme, Kano, Kano State",
      "College of Nursing Sciences, Accident & Emergency Nursing Programme, National Orthopaedic Hospital Dala, Kano State",
      "College of Nursing Sciences, Burns and Plastic Nursing Programme, National Orthopaedic Hospital Dala, Kano State",
      "College of Nursing Sciences, Community Midwifery Programme, Dambatta Campus, Kano State",
      "College of Nursing Sciences, Community Midwifery Programme, Gwarzo, Kano State",
      "College of Nursing Sciences, Community Midwifery Programme, Kano, Kano State",
      "College of Nursing Sciences, Community Nursing Programme, Kano, Kano State",
      "College of Nursing Sciences, Community Nursing Programme, Madobi Campus, Kano State",
      "College of Nursing Sciences, Critical Care Nursing Programme, AKTH, Kano, Kano State",
      "College of Nursing Sciences, Midwifery Programme, Dambatta Campus, Kano State",
      "College of Nursing Sciences, Midwifery Programme, Gezawa Campus, Kano State",
      "College of Nursing Sciences, Midwifery Programme, Gwarzo, Kano State",
      "College of Nursing Sciences, Midwifery Programme, Kano, Kano State",
      "College of Nursing Sciences, Midwifery Programme, Madobi Campus, Kano State",
      "College of Nursing Sciences, Nephrology Nursing Programme, AKTH, Kano, Kano State",
      "College of Nursing Sciences, Nursing Programme, Kano, Kano State",
      "College of Nursing Sciences, Nursing Programme, Madobi Campus, Kano State",
      "College of Nursing Sciences, Ophthalmic  Nursing Programme, Kano, Kano State",
      "College of Nursing Sciences, Orthopaedic Nursing Programme, National Orthopaedic Hospital Dala, Kano State",
      "College of Nursing Sciences, Paediatric Nursing Programme, AKTH, Kano, Kano State",
      "College of Nursing Sciences, Perioperative Nursing Programme, AKTH, Kano, Kano State",
      "Dansharif College of Nursing Sciences, Midwifery Programme, Kano, Kano State",
      "Dansharif College of Nursing Sciences, Nursing Programme, Kano, Kano State",
      "Department of Nursing Sciences, Al-Istiqama University, Sumaila, Kano State",
      "Department of Nursing Sciences, Bayero University, Kano, Kano State",
      "Emirate College of Nursing Sciences, Midwifery Programme, Kano, Kano State",
      "Emirate College of Nursing Sciences, Nursing Programme, Kano, Kano State",
      "Faculty of Nursing Sciences, Maryam Abacha American University of Nigeria, Kano, Nigeria",
      "Hamdala College of Nursing Sciences, Midwifery Programme, Kano, Kano State",
      "Hamdala College of Nursing Sciences, Nursing Programme, Kano, Kano State",

      "Nafisatu College of Nursing Sciences, Community Midwifery Programme, Kwankwaso, Kano State",
      "Nafisatu College of Nursing Sciences, Community Nursing Programme, Kwankwaso, Kano State",
      "Nafisatu College of Nursing Sciences, Midwifery Programme, Kwankwaso, Kano State",
      "Nafisatu College of Nursing Sciences, Nursing Programme, Kwankwaso, Kano State",
      "School of Post Basic Critical Care Nursing, AKTH, Kano, Kano State",
      "Sudawa College of Nursing Sciences, Midwifery Programme, Kano, Kano State",
      "Sudawa College of Nursing Sciences, Nursing Programme, Kano, Kano State",
      "Umaru Ringim College of Nursing Sciences, Nurse Anaesthesia Programme, Kano, Kano State",
    ],
  },
  {
    state: "Katsina",
    schools: [
      "Bawo College of Nursing Sciences, Midwifery Programme, Katsina, Katsina State",
      "Bawo College of Nursing Sciences, Nursing Programme, Katsina, Katsina State",
      "Cherish College of Nursing Sciences, Midwifery Programme, Batsari, Katsina State",
      "Cherish College of Nursing Sciences, Nursing Programme, Batsari, Katsina State",
      "College of Nursing Sciences, Community Midwifery, Malumfashi, Katsina State",
      "College of Nursing Sciences, Community Nursing Programme, Katsina, Katsina State",
      "College of Nursing Sciences, Midwifery Programme, Katsina, Katsina State",
      "College of Nursing Sciences, Midwifery Programme, Malumfashi, Katsina State",
      "College of Nursing Sciences, Nursing Programme, Katsina, Katsina State",
      "College of Nursing Sciences, Nursing Programme, Malumfashi, Katsina State",
      "College of Nursing Sciences, Public Health Nursing Programme, Katsina, Katsina State",
      "EssEmm College of Nursing Sciences, Midwifery Programme, Katsina, Katsina State",
      "EssEmm College of Nursing Sciences, Nursing Programme, Katsina, Katsina State",
      "North West College of Nursing Sciences, Midwifery Programme, Katsina, Katsina State",
      "North West College of Nursing Sciences, Nursing Programme, Katsina, Katsina State",
    ],
  },
  {
    state: "Kebbi",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Birnin-Kebbi, Kebbi State",
      "College of Nursing Sciences, Community Nursing Programme, Birnin-Kebbi, Kebbi State",
      "College of Nursing Sciences, Midwifery Programme, Birnin-Kebbi, Kebbi State",
      "College of Nursing Sciences, Nursing Programme, Birnin-Kebbi, Kebbi State",
      "Department of Nursing Sciences, Federal University, Birnin-Kebbi, Kebbi State",
      "Sajo College of Nursing Sciences, Midwifery Programme, Birnin Kebbi, Kebbi State",
      "Sajo College of Nursing Sciences, Nursing Programme, Birnin Kebbi,Kebbi State",
    ],
  },
  {
    state: "Kogi",
    schools: [
      "College of Nursing Sciences, Midwifery Programme, Obangede, Kogi State",
      "College of Nursing Sciences, Nursing Programme, Obangede, Kogi State",
      "College of Nursing Sciences, Nursing Programme, UEC, Ochadamu, Kogi state",
      "ECWA College of Nursing Sciences, Midwifery Programme,Egbe, Kogi State",
      "ECWA College of Nursing Sciences, Nursing Programme, Egbe, Kogi State",
      "Grimard Catholic College of Nursing Sciences, Midwifery Programme, Anyingba, Kogi State",
      "Grimard Catholic College of Nursing Sciences, Nursing Programme, Anyingba, Kogi State",
      "Nana College of Nursing Sciences, Midwifery Programme, Ayingba, Kogi State",
      "Nana College of Nursing Sciences, Nursing Programme, Ayingba, Kogi State",
      "Okunland College of Nursing Sciences, Midwifery Programme, Isanlu, Kogi State",
      "Okunland College of Nursing Sciences, Nursing Programme, Isanlu, Kogi State",
    ],
  },
  {
    state: "Kwara",
    schools: [
      "College of Nursing Sciences,  Midwifery Programme, Oke Ode, Kwara State",
      "College of Nursing Sciences, Accident & Emergency Nursing Programme, UITH, Ilorin, Kwara State",
      "College of Nursing Sciences, Community Midwifery Programme, Ilorin, Kwara State",
      "College of Nursing Sciences, Midwifery Programme, Ilorin, Kwara State",
      "College of Nursing Sciences, Nephrology Nursing Programme,UITH, Ilorin, Kwara State",
      "College of Nursing Sciences, Nursing Programme, Ilorin, Kwara State",
      "College of Nursing Sciences, Nursing Programme, Oke-Ode, Kwara State",
      "College of Nursing Sciences, Nursing Programme, UITH ,Ilorin  Kwara State",
      "College of Nursing Sciences, Nursing Programme,UITH, Ilorin, Kwara State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme,UITH, Ilorin, Kwara State",
      "College of Nursing Sciences, Paediatric Nursing Programme,UITH, Ilorin, Kwara State",
      "College of Nursing Sciences, Public Health Nursing Programme, Oke Ode, Kwara State",
      "Department of Nursing Science, UNILORIN, Ilorin, Kwara State",
      "Department of Nursing Sciences, Alhikma University, Ilorin, Kwara State",
      "Department of Nursing Sciences, Thomas Adewunmi University, Oko, Kwara State",
      "Department of Nursing Sciences, University of Ilorin, Ilorin, Kwara State",
    ],
  },
  {
    state: "Lagos",
    schools: [
      "College of Nursing Sciences,  Accident & Emergency Nursing Programme, LUTH, Idi-Araba, Lagos State",
      "College of Nursing Sciences,  Anaesthetic Nursing Programme, Badagry, Lagos State",
      "College of Nursing Sciences, Accident & Emergency Nursing Programme, National Orthopaedic Hospital, Igbobi, Lagos State",
      "College of Nursing Sciences, Critical Care Nursing Programme, LUTH, Idi-Araba, Lagos State",
      "College of Nursing Sciences, Mental Health/Psychiatric Nursing Programme, Federal Neuropsychiatric Hospital, Yaba, Lagos State",
      "College of Nursing Sciences, Midwifery Programme, Igando, Lagos State",
      "College of Nursing Sciences, Midwifery Programme, LUTH, Idi-Araba, Lagos State",
      "College of Nursing Sciences, National Orthopaedic Hospital, Igbobi, Lagos State",
      "College of Nursing Sciences, Neonatal Nursing Programme, LUTH, Idi-Araba, Lagos State",
      "College of Nursing Sciences, Nursing Programme, Igando, Lagos State",
      "College of Nursing Sciences, Nursing Programme, LUTH, Idi-Araba, Lagos State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme, LUTH, Idi-Araba, Lagos State",
      "College of Nursing Sciences, Orthopaedic Nursing Programme, National Orthopaedic Hospital, Igbobi, Lagos State",
      "College of Nursing Sciences, Paediatric Nursing Programme, LUTH, Idi-Araba, Lagos State",
      "College of Nursing Sciences, Perioperative Nursing Programme, LUTH, Idi-Araba, Lagos State",
      "Department of Nursing Sciences, Lagos State University, Ikeja, Lagos State",
      "Department of Nursing Sciences, Trinity University, Yaba, Lagos State",
      "Department of Nursing Sciences, University of Lagos, Idi-Araba, Lagos State",
      "Nigerian Army College of Nursing Sciences, Community Nursing Programme, Nigerian Army, Yaba, Lagos State",
      "Nigerian Army College of Nursing Sciences, Midwifery Programme, Yaba, Lagos State",
      "Nigerian Army College of Nursing Sciences, Nursing Programme, Yaba, Lagos",
      "School of Midwifery, Awolowo Road, Ikoyi",
      "School of Public Health Nursing, Awolowo Road, Ikoyi, Lagos State",
    ],
  },
  {
    state: "Nasarawa",
    schools: [
      "College of Nursing Sciences, Midwifery Programme, Lafia, Nasarawa State",
      "College of Nursing Sciences, Nursing Programme, Lafia, Nasarawa State",
      "Department of Nursing Sciences, Bingham University, Kodape, Karu, Nasarawa State",
      "Kariyoma College of Nursing Sciences, Nursing Programme, Lafia, Nasarawa State",
      "Kariyoma College of Nursing, Midwifery Programme",
    ],
  },
  {
    state: "Niger",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Kotangora, Niger State",
      "College of Nursing Sciences, Community Midwifery Programme, Minna, Niger State",
      "College of Nursing Sciences, Community Nursing Programme, Bida, Niger State",
      "College of Nursing Sciences, Community Nursing Programme, Kotangora, Niger State",
      "College of Nursing Sciences, Midwifery Programme, Bida, Niger State",
      "College of Nursing Sciences, Midwifery Programme, Kontogora, Niger State",
      "College of Nursing Sciences, Midwifery Programme, Minna, Niger State",
      "College of Nursing Sciences, Nursing Programme, Bida, Niger State",
      "College of Nursing Sciences, Nursing Programme, Kontogora, Niger State",
      "College of Nursing Sciences, Nursing Programme, Minna, Niger State",
      "Dako College of Nursing Sciences, Midwifery Programme, Suleja, Niger State",
      "Dako College of Nursing Sciences, Nursing Programme, Suleja, Niger State",
      "Department of Nursing Sciences, Newgate University, Minna, Niger State",
      "Standard College of Nursing Sciences, Community Midwifery Programme, Minna, Niger State",
      "Standard College of Nursing Sciences, Community Nursing Programme, Minna, Niger State",
      "Standard College of Nursing Sciences, Midwifery Programme, Minna, Niger State",
      "Standard College of Nursing Sciences, Nursing Programme, Minna, Niger State",
    ],
  },
  {
    state: "Ogun",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Abeokuta, Ogun State",
      "College of Nursing Sciences, Mental Health/ Psychiatric Nursing Programme, Federal Neuropsychiatric Hospital, Aro, Abeokuta, Ogun State",
      "College of Nursing Sciences, Midwifery Programme, Abeokuta, Ogun State.",
      "College of Nursing Sciences, Midwifery Programme, Ijebu-Ode, Ogun State",
      "College of Nursing Sciences, Nursing Programme, Abeokuta, Ogun State",
      "College of Nursing Sciences, Nursing Programme, Ijebu-Ode, Ogun State",
      "College of Nursing Sciences, Nursing Programme, Ilaro, Ogun State",
      "Department Of Education, Babcock University, Ilishan-Remo, Ogun State.",
      "Department of Nursing Science, Chrisland University, Owode, (Abeokuta Campus) Ogun State",
      "Department of Nursing Science, Crescent University, Abeokuta, Ogun State",
      "Department of Nursing Science, Olabisi Onabanjo University, Ago-Iwoye, Ogun State",
      "Department of Nursing, McPherson University, Seriki-Sotayo, Ogun State",
      "Jafad College of Nursing Sciences, Nursing Programme, Oru Ijebu, Ogun State",
      "Sacred Heart College of Nursing Sciences, Nursing Programme, Lantoro, Abeokuta, Ogun State",
      "School of Nursing, Babcock University, Ilishan-Remo, Ogun State",
      "Sacred Heart College of Nursing Sciences, Nursing Programme, Lantoro, Ogun State",
      "College of Nursing Science, Community Midwifery Program, Oba Ademola II, Ogun State",
    ],
  },
  {
    state: "Ondo",
    schools: [
      "Achievers College of Nursing Sciences , Midwifery Programme, Akure, Ondo State",
      "Achievers College of Nursing Sciences , Nursing Programme, Akure, Ondo State",
      "College of Nursing Sciences, Community Midwifery Programme, Akure, Ondo State",
      "College of Nursing Sciences, Community Nursing Programme, Akure, Ondo State",
      "College of Nursing Sciences, Midwifery Programme,  Akure, Ondo State",
      "College of Nursing Sciences, Nursing Programme, Akure, Ondo State",
      "Department of Nursing Science, Elizade University, Ilara Mokin, Ondo State",
      "Department of Nursing, Achievers University Owo, Ondo State",
      "Faculty of Nursing Sciences, University of Medical Sciences, Ondo, Ondo State",
      "Peacock College of Nursing Sciences, Midwifery Programme, Akure, Ondo State",
      "Peacock College of Nursing Sciences, Nursing Programme, Akure, Ondo State",
    ],
  },
  {
    state: "Osun",
    schools: [
      "College of Nursing Sciences, Midwifery Programme, OAUTHC, WGH, Ilesa, Osun State",
      "College of Nursing Sciences, Midwifery Programme, Osogbo, Osun State",
      "College of Nursing Sciences, Nursing Programme, OAUTHC, Ile-Ife, Osun State",
      "College of Nursing Sciences, Nursing Programme, OAUTHC, WGH, Ilesa, Osun State",
      "College of Nursing Sciences, Nursing Programme, Osogbo, Osun State",
      "College of Nursing Sciences, Peadiatric Nursing Programme, UNIOSUN Teaching Hospital, Idi-Seke, Osogbo, Osun State",
      "College of Nursing Sciences, Perioperative Nursing Programme, OAUTHC, IIe-Ife, Osun State",
      "Department of Nursing Science, Bowen University, Iwo, Osun State",
      "Department of Nursing Science, Obafemi Awolowo University, Ile-Ife, Osun State",
      "Department of Nursing Science, Redeemers University, Ede, Osun State",
      "Department of Nursing Sciences, Adeleke University, Ede, Osun State",
      "Department of Nursing Sciences, Bowen University, Iwo, Osun State",
      "Department of Nursing Sciences, Fountain University, Osogbo, Osun State",
      "Department of Nursing Sciences, Joseph  Ayo Babalola University, Ikeji Arakeji, Osun State",
      "Department of Nursing, Osun State University, Osogbo, Osun State",
      "Mercy College of Nursing Sciences, Midwifery Programme, Ido-Osun, Osun State",
      "Mercy College of Nursing Sciences, Nursing Programme, Ido-Osun, Osun State",
      "Seventh-Day Adventist College of Nursing Sciences, Nursing Programme, Lagere, Ile-Ife, Osun State",
    ],
  },
  {
    state: "Oyo",
    schools: [
      "Baptist College of Nursing Sciences, Midwifery Programme, Saki, Oyo State",
      "Baptist College of Nursing Sciences, Nursing Programme, Saki, Oyo State",
      "Catholic Archdiocese Ibadan College of Nursing Sciences, Nursing Programme, Oluyoro, Ibadan, Oyo State",
      "College of Nursing Sciences, Community Midwifery Programme, Kishi, Oyo State",
      "College of Nursing Sciences, Community Nursing Programme, Eleyele, Ibadan, Oyo State",
      "College of Nursing Sciences, Midwifery Programme, BUTH, Ogbomosho, Oyo State",
      "College of Nursing Sciences, Midwifery Programme, Eleyele, Oyo State",
      "College of Nursing Sciences, Midwifery Programme, Kishi, Oyo State",
      "College of Nursing Sciences, Midwifery Programme, Muslim Medical Foundation, Saki, Oyo State",
      "College of Nursing Sciences, Midwifery Programme, Muslim Medical Foundation,Saki, Oyo State",
      "College of Nursing Sciences, Midwifery Programme, Oluyoro, Oyo State",
      "College of Nursing Sciences, Midwifery Programme, UCH, Ibadan, Oyo State",
      "College of Nursing Sciences, Nursing Programme, BUTH, Ogbomosho, Oyo State",
      "College of Nursing Sciences, Nursing Programme, Eleyele ,Ibadan, Oyo State",
      "College of Nursing Sciences, Nursing Programme, Eleyele, Ibadan, Oyo State",
      "College of Nursing Sciences, Nursing Programme, Muslim Medical Foundation, Saki, Oyo State",
      "College of Nursing Sciences, Nursing Programme, UCH, Ibadan, Oyo State",
      "College of Nursing Sciences, Occupational Health Nursing Programme, UCH, Ibadan, Oyo State",
      "College of Nursing Sciences, Oral-Dental Health Nursing Programme, Eleyele, Ibadan, Oyo State",
      "College of Nursing Sciences, Perioperative Nursing Programme, UCH, Ibadan, Oyo State",
      "Department of Nursing Science, University of Ibadan, Ibadan, Oyo State",
      "Department of Nursing Sciences, Atiba University, Iseyin Road, Ibadan, Oyo State",
      "Department of Nursing, Lead City University, Ibadan, Oyo State",
      "Faculty of Nursing Sciences, LAUTECH, Ogbomoso",
    ],
  },
  {
    state: "Plateau",
    schools: [
      "Adventist College of Nursing Sciences, Midwifery Programme, Jengre, Plateau State",
      "Adventist College of Nursing Sciences, Nursing Programme, Jengre, Plateau State",
      "College of Nursing Sciences,  Anaesthetic Nursing Programme, JUTH, Jos, Plateau State",
      "College of Nursing Sciences, Anaesthetic Nursing Programme, JUTH, Jos, Plateau State",
      "College of Nursing Sciences, Critical Care Nursing Programme, JUTH, Jos, Plateau State",
      "College of Nursing Sciences, Midwifery Programme, MMH, Jos, Plateau State",
      "College of Nursing Sciences, Midwifery Programme, OLAH, Jos, Plateau State",
      "College of Nursing Sciences, Midwifery Programme, Vom, Plateau State",
      "College of Nursing Sciences, Nephrology Nursing Programme, JUTH, Jos, Plateau State",
      "College of Nursing Sciences, Nursing Programme, MMH, Jos, Plateau State",
      "College of Nursing Sciences, Nursing Programme, Vom, Plateau State",
      "College of Nursing Sciences, Ophthalmic Nursing Programme, JUTH, Jos, Plateau State",
      "College of Nursing Sciences, Perioperative Nursing Programme, JUTH, Jos, Plateau State",
      "Department of Nursing Sciences, University of Jos, Jos, Plateau State",
      "Hill College of Nursing Sciences, Midwifery Programme, Jos, Plateau State",
      "Hill College of Nursing Sciences, Nursing Programme, Jos, Plateau State",
      "Jibape Memorial College of Nursing, Midwifery Programme, Jengre, Plateau State",
      "Jibape Memorial College of Nursing, Nursing Programme, Jengre, Plateau State",
    ],
  },
  {
    state: "Rivers",
    schools: [
      "College of Nursing Sciences, Accident & Emergency Nursing Programme, UPTH, Port-Harcourt,  Rivers State",
      "College of Nursing Sciences, Midwifery Programme, Port Harcourt, Rivers State",
      "College of Nursing Sciences, Nursing Programme, Portharcourt, Rivers State",
      "College of Nursing Sciences, Paediatric Nursing Programme, UPTH, Port-Harcourt, Rivers State",
      "Department of Nursing Sciences, PAMO University of Medical Sciences, Portharcourt, Rivers State",
      "Department of Nursing Sciences, Rivers State Univesity, Portharcourt, Rivers State",
      "Department of Nursing Sciences, University of Portharcourt, Portharcourt, Rivers State",
      "Faculty of Nursing Sciences, Madonna University, Elele, Rivers State",
    ],
  },
  {
    state: "Sokoto",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Sokoto, Sokoto State",
      "College of Nursing Sciences, Community Midwifery Programme, Tambuwal, Sokoto State",
      "College of Nursing Sciences, Community Nursing Programme, Sokoto, Sokoto State",
      "College of Nursing Sciences, Community Nursing Programme, Tambuwal, Sokoto State",
      "College of Nursing Sciences, Mental Health/ Psychiatric Nursing Programme, Federal Neuropsychiatric Hospital, Kware, Sokoto State",
      "College of Nursing Sciences, Midwifery Programme, Sokoto, Sokoto State",
      "College of Nursing Sciences, Midwifery Programme, Tambuwal, Sokoto State",
      "College of Nursing Sciences, Midwifery Programme, UDUTH, Sokoto, Sokoto State",
      "College of Nursing Sciences, Nursing Programme, Sokoto, Sokoto State",
      "College of Nursing Sciences, Nursing Programme, Tambuwal, Sokoto State",
      "College of Nursing Sciences, Nursing Programme, UDUTH, Sokoto, Sokoto State",
      "College of Nursing Sciences, Paediatric Nursing Programme, UDUTH, Sokoto, Sokoto State",
      "College of Nursing Sciences, Perioperative Nursing Programme, UDUTH, Sokoto, Sokoto State",
      "Department of Nursing Science, Usman Danfodio University, Sokoto, Sokoto State",
      "Fatima  College of Nursing Sciences, Midwifery Programme, Sifawa, Sokoto State",
      "Fatima  College of Nursing Sciences, Nursing Programme, Sifawa, Sokoto State",
      "Gamji College of Nursing Sciences, Midwifery Programme, Sokoto, Sokoto State",
      "Gamji College of Nursing Sciences, Nursing Programme, Sokoto, Sokoto State",
    ],
  },
  {
    state: "Taraba",
    schools: [
      "A.B. Na'ibi College of Nursing Sciences, Midwifery Programme, Lau, Taraba State",
      "A.B. Na'ibi College of Nursing Sciences, Nursing Programme, Lau, Taraba State",
      "Beulah College of Nursing Sciences, Midwifery Programme, Jalingo, Taraba State",
      "Beulah College of Nursing Sciences, Nursing Programme, Jalingo, Taraba State",
      "College of Nursing Sciences, Community Midwifery Programme, Jalingo, Taraba State.",
      "College of Nursing Sciences, Community Nursing Programme, Jalingo, Taraba State",
      "College of Nursing Sciences, Midwifery Programme, Jalingo, Taraba State",
      "College of Nursing Sciences, Nursing Programme, Jalingo, Taraba State",
      "Department of Nursing Sciences, Taraba State University, Jalingo, Taraba State",
    ],
  },
  {
    state: "Yobe",
    schools: [
      "Al-Ma'arif College of Nursing Sciences, Community Midwifery Programme, Potiskum, Yobe State",
      "Al-Ma'arif College of Nursing Sciences, Community Nursing Programme, Potiskum, Yobe State",
      "Al-Ma'arif College of Nursing Sciences, Midwifery Programme, Potiskum, Yobe State",
      "Al-Ma'arif College of Nursing Sciences, Nursing Programme, Potiskum, Yobe State",
      "College of Nursing Sciences, Community Midwifery Programme, Damaturu, Yobe State",
      "College of Nursing Sciences, Community Nursing Programme, Damaturu, Yobe State",
      "College of Nursing Sciences, Midwifery Programme, Damaturu, Yobe State",
      "College of Nursing Sciences, Midwifery Programme, FMC, Nguru, Yobe State",
      "College of Nursing Sciences, Nursing Programme, Damaturu, Yobe State",
      "College of Nursing Sciences, Nursing Programme, FMC, Nguru, Yobe State",
      "College of Nursing Sciences, School of Nursing, FMC, Nguru, Yobe State",
    ],
  },
  {
    state: "Zamfara",
    schools: [
      "College of Nursing Sciences, Community Midwifery Programme, Gusau, Zamfara State",
      "College of Nursing Sciences, Community Nursing Programme, Gusau, Zamfara State",
      "College of Nursing Sciences, Midwifery Programme, Gusau, Zamfara State",
      "College of Nursing Sciences, Nursing Programme, Gusau, Zamfara State",
      "Umar Bin Khaddabi College of Nursing Sciences, Midwifery Programme, Kaura Namoda, Zamfara State",
      "Umar Bin Khaddabi College of Nursing Sciences, Nursing Programme, Kaura Namoda, Zamfara State",
      "Ummul-Khari College of Nursing Sciences, Midwifery Programme, Gusau, Zamfara State",
      "Ummul-Khari College of Nursing Sciences, Nursing Programme, Gusau, Zamfara State",
    ],
  },
];
